import React from 'react';
import * as Icon from "react-feather";
import Image from 'gatsby-image';
import { OutboundLink } from 'gatsby-plugin-google-analytics';

const Post = ({post}) => {
    const {caption, id, comments, likes, localFile} = post;
    return (
        <div className="card">
            <Image
                className="card-img-top w-100"
                fixed={localFile.childImageSharp.fixed}
            />
            <div className="card-body">
                <div className="d-flex justify-content-between mb-2 border-bottom pb-2">
                    <div>
                        <Icon.Heart color="red" />
                        <span className="font-weight-bold ml-1 mr-1">{likes} Like</span>
                    </div>
                    <div>
                        <Icon.MessageCircle />
                        <span className="font-weight-bold ml-1">{comments ? comments : 0} Comment</span>
                    </div>
                </div>
                    
                <p className="card-text">{caption}</p>                
                <p><OutboundLink rel="noopener noreferrer" href={`https://www.instagram.com/p/${id}/`} target="_blank">Post</OutboundLink> is all about delivering a fantastic user experience.</p>
            </div>
        </div>
    );
}
 
export default Post;